angular.module("vgresiduos").component("chip", {
	controllerAs: "ctrl",
	templateUrl: "views/components/chip/chip_template.html",
	bindings: {
		text: "@",
		textTooltip: "@"
	}
});
